export default __webpack_public_path__ + "static/media/SAMF_09_mos.8ad00ec4.wav";